import type { UnknownAction } from 'redux';
import type { ErrorType } from '../../use-cases/auth/errors';
import type { AuthResult } from '../../use-cases/auth/types';
import type { AuthError } from './authReducer';

export type AuthAction = UserLoggedInAction | NoSessionFoundAction | FatalErrorAction;

export interface UserLoggedInAction extends UnknownAction {
  payload: {
    authResult: AuthResult;
  };
  type: 'AUTH:USER_LOGGED_IN';
}

export const userLoggedIn = (authResult: AuthResult): UserLoggedInAction => ({
  payload: {
    authResult,
  },
  type: 'AUTH:USER_LOGGED_IN',
});

export interface UserLoggedOutAction extends UnknownAction {
  payload: {};
  type: 'AUTH:USER_LOGGED_OUT';
}

export const userLoggedOut = (): UserLoggedOutAction => ({
  payload: {},
  type: 'AUTH:USER_LOGGED_OUT',
});

export interface NoSessionFoundAction extends UnknownAction {
  payload: {};
  type: 'AUTH:NO_SESSION_FOUND';
}

export const noSessionFound = (): NoSessionFoundAction => ({
  payload: {},
  type: 'AUTH:NO_SESSION_FOUND',
});

export interface FatalErrorAction extends UnknownAction {
  payload: AuthError;
  type: 'AUTH:FATAL_ERROR';
}

export const fatalError = (type: ErrorType, description: string): FatalErrorAction => ({
  payload: {
    type,
    description,
  },
  type: 'AUTH:FATAL_ERROR',
});
